
import { defineComponent, ref, onMounted, nextTick, watch } from 'vue';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default defineComponent({
  name: 'WorldSwiper',
  props: ['isUpdate'],
  setup(props: any) {
    const swiperData = ref([
      {
        id: 1,
        img: require('@images/frxx/world-1.png'),
        textTitle: '黃楓谷',
        textDesc: '初踏天南，仙途啓程。 ',
      },
      {
        id: 2,
        img: require('@images/frxx/world-2.png'),
        textTitle: '血色禁地',
        textDesc: '修仙世界，强者爲尊。',
      },
      {
        id: 3,
        img: require('@images/frxx/world-3.png'),
        textTitle: '墜魔谷',
        textDesc: '奇靈古獸，一絕生殺。',
      },
    ]);
    let swiper = null;
    const initSwiper = () => {
      swiper = new Swiper('.swiper-container-world', {
        loop: true,
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        direction: 'horizontal',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        effect: 'fade',
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      });
    };
    watch(
      () => props.isUpdate,
      (newVal, oldVal) => {
        if (newVal && !oldVal) {
          swiper.update();
        }
      },
    );
    onMounted(() => {
      nextTick(() => {
        initSwiper();
      });
    });
    return {
      swiperData,
    };
  },
});
